import config from "./config";
import Viewer from "viewerjs";

const util = {
  getQueryValue(key) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const res = urlParams.get(key);
    return res == null ? "" : res;
  },
  isApp() {
    let res = false;
    const platform = util.getPlatform();
    if (platform == "ios") {
      const standalone = window.navigator.standalone;
      const userAgent = window.navigator.userAgent.toLowerCase();
      const safari = /safari/.test(userAgent);
      const ios = /iphone|ipod|ipad/.test(userAgent);
      if (ios && !standalone && !safari) {
        res = true;
      }
    } else if (platform == "android") {
      if (typeof uiObject != "undefined" && typeof uiObject.getInfo != "undefined") {
        res = true;
      }
    }
    return res;
  },
  getPlatform() {
    let res = "pc";
    if (util.isMobileAccess()) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.match(/android/i)) {
        res = "android";
      } else if (userAgent.match(/(iphone|ipad|ipod|ios)/i)) {
        res = "ios";
      }
    }
    return res;
  },
  isMobileAccess() {
    let res = false;
    const userAgent = navigator.userAgent.toLowerCase();
    const userAgents = ["Windows CE", "iPad", "iPhone", "iPod", "Android", "android", "Windows Phone", "Symbian", "BlackBerry", "Linux"];
    userAgents.forEach((text) => {
      if (userAgent.indexOf(text.toLowerCase()) !== -1) {
        res = true;
      }
    });
    return res;
  },
  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  setImgClick() {
    $(".content img").removeAttr("width").removeAttr("height");
    const imgs = $(".content img");
    for (let i = 0; i < imgs.length; i++) {
      const img = $(imgs[i]);
      const src = img.attr("src");
      if (src.includes("http") && !src.includes("//images") && !src.includes("172.20")) {
        new Viewer(img.get(0), {
          title: false,
          toolbar: false,
          navbar: false,
        });
      }
    }
  },
  isFromApp() {
    const userAgent = navigator.userAgent;
    return Boolean(userAgent.match(/interapp/gi));
  },
  saveParameter(key) {
    const value = util.getQueryValue(key);
    if (value.length != 0) {
      util.setCookie(key, value);
    }
  },
  setCookie(name, value, day = 1) {
    const d = new Date();
    d.setTime(d.getTime() + day * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },
};
export default util;
